
export const Article13 = () => {
    return (
        <div>
            <p>Haga clic <a href={"https://centronaval.org.ar/boletin/BCN818/818araujo.pdf"} target={"_blank"} rel={"noreferrer noopener"}>aquí</a> para ver el contenido completo.</p>
        </div>
    )
}